import React, { useEffect } from 'react';
import GenericFullLoadingPage from '@core/myta/pages/GenericFullLoadingPage';
import { MytaverseEventProvider } from '@core/dashboard/providers';
import { useCheckUniqueApplicationAccessPerAccount } from '../hooks/permissions';
import { useInitPrivateRoutesState } from './hooks';
import VideoGamecast from '../components/VideoGameCast';
import { useMytaverse } from '../providers/MytaverseProvider';
import ExternalEventPageContent from '@core/event/pages/ExternalEventPage/ExternalEventPageContent';
import { useLocation } from 'react-router-dom';
import UnfinishedAvatarModal from '@core/avatar/components/UnfinishedAvatarModal';
import EventFullLoadingPage from '@core/event/pages/EventFullLoadingPage';

const EventPageContainer: React.FC = () => {
  const hasMultipleConnections = useCheckUniqueApplicationAccessPerAccount();
  const initializing = useInitPrivateRoutesState();
  const [teleportButtonClicked, setTeleportButtonClicked] =
    React.useState(false);
  const { navigateToEventsPage } = useMytaverse();
  const { state } = useLocation();

  useEffect(() => {
    if (hasMultipleConnections) {
      navigateToEventsPage({
        message: 'notifications.duplicateGamecastSession',
      });
    }
  }, [hasMultipleConnections, navigateToEventsPage]);

  if (initializing) {
    return <EventFullLoadingPage />;
  }

  if (hasMultipleConnections) {
    // this doesn't really matter as we redirect to events page
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (!teleportButtonClicked && state?.isExternalEvent) {
    return (
      <ExternalEventPageContent
        setTeleportButtonClicked={setTeleportButtonClicked}
      />
    );
  }

  return (
    <>
      <MytaverseEventProvider />
      <VideoGamecast />
      <UnfinishedAvatarModal />
    </>
  );
};

export default EventPageContainer;
